<!-- Footer -->
<footer class="n-footer" id="contact">
  <div class="n-footer-content">
    <div class="n-footer-section">
      <object
        class="n-footer-logo"
        data="../../../assets/icons/nomoh_logo_white.svg"
        type="image/svg+xml"
      ></object>
      <p class="n-footer-description">
        Startup inovadora focada em criar soluções tecnológicas que simplificam
        a vida e impulsionam negócios.
      </p>
      <div class="n-social-links">
        <a href="#" class="n-social-link"><i class="pi pi-linkedin"></i></a>
        <a href="#" class="n-social-link"><i class="pi pi-github"></i></a>
        <a href="#" class="n-social-link"><i class="pi pi-instagram"></i></a>
      </div>
    </div>

    <div class="n-footer-section">
      <h3 class="n-footer-title">{{ "RODAPE.EMPRESA" | translate }}</h3>
      <a href="#about" class="n-footer-link">Sobre a Nomoh</a>
      <a href="#team" class="n-footer-link">Nosso Time</a>
      <a href="#cases" class="n-footer-link">Cases de Sucesso</a>
      <a href="#products" class="n-footer-link">{{
        "RODAPE.SOLUÇÕES" | translate
      }}</a>
    </div>

    <div class="n-footer-section">
      <h3 class="n-footer-title">Produtos</h3>
      <a href="#products" class="n-footer-link">Bardo - Agendamentos</a>
      <a href="#products" class="n-footer-link">Integrator - Marketplaces</a>
      <a href="#products" class="n-footer-link">Sites Sob Medida</a>
    </div>

    <div class="n-footer-section">
      <h3 class="n-footer-title">{{ "RODAPE.SUPORTE" | translate }}</h3>
      <a
        href="https://api.whatsapp.com/send/?phone=553199179151&text=Ol%C3%A1%21+Visitei+seu+site+e+gostaria+de+conhecer+seus+servi%C3%A7os&type=phone_number&app_absent=0"
        class="n-footer-link"
      >
        📧 {{ "RODAPE.EMAIL" | translate }}
      </a>
      <a
        href="https://api.whatsapp.com/send/?phone=553199179151&text=Ol%C3%A1%21+Visitei+seu+site+e+gostaria+de+conhecer+seus+servi%C3%A7os&type=phone_number&app_absent=0"
        class="n-footer-link"
      >
        📱 (31) 99917-9151
      </a>
      <span class="n-footer-text">📍 Belo Horizonte, MG</span>
    </div>

    <div class="n-footer-section">
      <h3 class="n-footer-title">Legal</h3>
      <a class="n-footer-link cursor" (click)="showDialogTermo()">
        {{ "RODAPE.TERMOS_SERVICO" | translate }}
      </a>
      <a class="n-footer-link cursor" (click)="showDialogPolitica()">
        {{ "RODAPE.POLITICAS_PRIVACIDADE" | translate }}
      </a>
    </div>
  </div>

  <div class="n-footer-bottom">
    <p class="n-footer-copy">
      {{ "RODAPE.COPYRIGHT" | translate }} Feito com ❤️ pela equipe Nomoh.
    </p>
  </div>
</footer>

<!-- Dialog Política de Privacidade -->
<p-dialog
  header="Política de Privacidade"
  [modal]="true"
  [(visible)]="visibleDialogPolitica"
  [style]="{ width: '50rem' }"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  styleClass="n-dialog-modern"
>
  <div class="n-dialog-content">
    <p class="n-dialog-intro">
      Esta Política de Privacidade descreve como coletamos, usamos, armazenamos
      e protegemos as informações pessoais dos usuários que acessam e utilizam
      nossos serviços. Ao usar nossos serviços, você concorda com os termos
      desta política.
    </p>

    <div class="n-dialog-section">
      <h2>1. Coleta de Informações</h2>
      <p>
        Coletamos as seguintes informações pessoais quando você utiliza nossos
        serviços:
      </p>
      <ul>
        <li>
          <strong>Informações fornecidas diretamente pelo usuário:</strong>
          <ul>
            <li>Nome completo;</li>
            <li>Endereço de e-mail;</li>
            <li>Número de telefone;</li>
            <li>Informações de pagamento (quando aplicável).</li>
          </ul>
        </li>
        <li>
          <strong>Informações coletadas automaticamente:</strong>
          <ul>
            <li>Endereço IP;</li>
            <li>Tipo de dispositivo e navegador;</li>
            <li>Páginas acessadas e tempo de navegação;</li>
            <li>Cookies e outras tecnologias de rastreamento.</li>
          </ul>
        </li>
      </ul>
    </div>

    <div class="n-dialog-section">
      <h2>2. Uso das Informações</h2>
      <p>Utilizamos as informações pessoais coletadas para:</p>
      <ul>
        <li>Fornecer e melhorar nossos serviços;</li>
        <li>Processar pagamentos e compras;</li>
        <li>Responder a solicitações de suporte;</li>
        <li>Enviar comunicações promocionais (com consentimento prévio);</li>
        <li>Garantir a segurança dos nossos serviços.</li>
      </ul>
    </div>

    <div class="n-dialog-section">
      <h2>3. Compartilhamento de Informações</h2>
      <p>
        Não compartilhamos suas informações pessoais com terceiros, exceto nas
        seguintes circunstâncias:
      </p>
      <ul>
        <li>Para cumprir obrigações legais ou ordens judiciais;</li>
        <li>
          Com provedores de serviços terceirizados contratados para operar ou
          melhorar nossos serviços (ex.: provedores de hospedagem);
        </li>
        <li>Com seu consentimento explícito.</li>
      </ul>
    </div>

    <div class="n-dialog-section">
      <h2>4. Segurança dos Dados</h2>
      <p>
        Adotamos medidas de segurança técnicas e organizacionais para proteger
        suas informações contra acessos não autorizados, perda ou destruição. No
        entanto, nenhum sistema é completamente seguro, e não podemos garantir a
        segurança absoluta.
      </p>
    </div>

    <div class="n-dialog-section">
      <h2>5. Seus Direitos</h2>
      <p>
        Você tem os seguintes direitos em relação às suas informações pessoais:
      </p>
      <ul>
        <li>Acessar, corrigir ou atualizar seus dados pessoais;</li>
        <li>
          Solicitar a exclusão de suas informações pessoais, quando aplicável;
        </li>
        <li>
          Retirar o consentimento para o uso de seus dados (quando aplicável);
        </li>
        <li>Reclamar junto às autoridades de proteção de dados.</li>
      </ul>
      <p>
        Para exercer seus direitos, entre em contato conosco através do e-mail:
        <strong>{{ "RODAPE.EMAIL" | translate }}</strong
        >.
      </p>
    </div>

    <div class="n-dialog-section">
      <h2>6. Retenção de Dados</h2>
      <p>
        Manteremos suas informações pessoais pelo período necessário para
        cumprir os propósitos descritos nesta política, a menos que um período
        maior seja exigido por lei.
      </p>
    </div>

    <div class="n-dialog-section">
      <h2>7. Cookies</h2>
      <p>
        Utilizamos cookies para melhorar a experiência do usuário, analisar o
        tráfego e personalizar o conteúdo. Você pode gerenciar suas preferências
        de cookies diretamente nas configurações do navegador.
      </p>
    </div>

    <div class="n-dialog-section">
      <h2>8. Alterações nesta Política</h2>
      <p>
        Reservamo-nos o direito de alterar esta Política de Privacidade a
        qualquer momento. Notificaremos sobre alterações substanciais por meio
        de aviso em nosso site ou por outros canais adequados. Recomendamos que
        revise esta política periodicamente.
      </p>
    </div>

    <div class="n-dialog-section">
      <h2>9. Contato</h2>
      <p>
        Se você tiver dúvidas ou preocupações sobre esta Política de
        Privacidade, entre em contato conosco:
      </p>
      <ul>
        <li><strong>E-mail:</strong> {{ "RODAPE.EMAIL" | translate }}</li>
        <li><strong>Telefone:</strong>(31) 9 9917-9151 (WhatsApp)</li>
      </ul>
    </div>
  </div>
</p-dialog>

<!-- Dialog Termos de Serviço -->
<p-dialog
  header="Termos de Serviço"
  [(visible)]="visibleDialogTermo"
  [modal]="true"
  [style]="{ width: '50rem' }"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  styleClass="n-dialog-modern"
>
  <div class="n-dialog-content">
    <p class="n-dialog-intro">
      Bem-vindo aos nossos serviços. Ao acessar ou utilizar nossos serviços,
      você concorda em cumprir os Termos de Serviço descritos abaixo. Caso não
      concorde, recomendamos que não utilize nossos serviços.
    </p>

    <div class="n-dialog-section">
      <h2>1. Aceitação dos Termos</h2>
      <p>
        Ao acessar nossos serviços, você concorda com os Termos de Serviço e
        todas as políticas e diretrizes complementares. Estes termos podem ser
        atualizados periodicamente, e recomendamos que você os revise
        regularmente.
      </p>
    </div>

    <div class="n-dialog-section">
      <h2>2. Uso dos Serviços</h2>
      <p>
        Você concorda em utilizar nossos serviços apenas para fins legais e de
        acordo com as seguintes condições:
      </p>
      <ul>
        <li>Não violar quaisquer leis aplicáveis;</li>
        <li>
          Não tentar acessar áreas restritas ou não autorizadas do sistema;
        </li>
        <li>
          Não utilizar os serviços para disseminar conteúdo malicioso,
          prejudicial ou ilegal.
        </li>
      </ul>
    </div>

    <div class="n-dialog-section">
      <h2>3. Registro de Conta</h2>
      <p>
        Para acessar alguns de nossos serviços, você pode precisar criar uma
        conta. Você é responsável por manter a confidencialidade de suas
        credenciais e por todas as atividades realizadas com sua conta.
      </p>
    </div>

    <div class="n-dialog-section">
      <h2>4. Direitos de Propriedade Intelectual</h2>
      <p>
        Todo o conteúdo, incluindo textos, imagens, gráficos, logotipos e outros
        materiais disponíveis em nossos serviços, é protegido por direitos de
        propriedade intelectual e não pode ser utilizado sem autorização prévia.
      </p>
    </div>

    <div class="n-dialog-section">
      <h2>5. Limitação de Responsabilidade</h2>
      <p>
        Nós nos esforçamos para fornecer serviços de qualidade, mas não
        oferecemos garantias sobre sua precisão, funcionalidade ou
        disponibilidade. Não seremos responsáveis por quaisquer danos diretos ou
        indiretos resultantes do uso de nossos serviços.
      </p>
    </div>

    <div class="n-dialog-section">
      <h2>6. Rescisão</h2>
      <p>
        Reservamo-nos o direito de suspender ou encerrar seu acesso aos serviços
        a qualquer momento, sem aviso prévio, caso você viole estes Termos de
        Serviço.
      </p>
    </div>

    <div class="n-dialog-section">
      <h2>7. Alterações nos Termos</h2>
      <p>
        Podemos alterar estes Termos de Serviço a qualquer momento. As
        alterações entrarão em vigor assim que publicadas em nosso site.
        Recomendamos que você revise os termos periodicamente.
      </p>
    </div>

    <div class="n-dialog-section">
      <h2>8. Contato</h2>
      <p>
        Se você tiver dúvidas ou preocupações sobre estes Termos de Serviço,
        entre em contato conosco:
      </p>
      <ul>
        <li><strong>E-mail:</strong> {{ "RODAPE.EMAIL" | translate }}</li>
        <li><strong>Telefone:</strong> (31) 9917-9151 (WhatsApp)</li>
      </ul>
    </div>
  </div>
</p-dialog>
